// @flow
import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../layout'
import Programme from '../components/programme'

function ProgrammePage() {
  return (
    <Layout>
      <Helmet>
        <title>Programme</title>
      </Helmet>
      <h1>Programme</h1>
      <Programme />
    </Layout>
  )
}

export default ProgrammePage
